export default __webpack_public_path__ + "static/property-about-e34051ba69baad9b3c4698ff128a3481.jpg";